// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");

function SettingsMenu$MenuItem(props) {
  var collapsed = props.collapsed;
  var onClick = props.onClick;
  var isSelected = props.isSelected;
  var label = props.label;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("span", {
                      children: props.icon,
                      className: "text-lg transition-transform duration-200 " + (
                        collapsed ? "" : "mr-3 "
                      ) + (
                        isSelected ? "scale-110" : "group-hover:scale-110"
                      )
                    }),
                collapsed ? null : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx("span", {
                                children: label,
                                className: "text-sm font-medium flex-1 " + (
                                  isSelected ? "font-semibold" : ""
                                )
                              }),
                          isSelected ? JsxRuntime.jsx("span", {
                                  className: "ml-2 w-1.5 h-1.5 bg-blue-600 rounded-full"
                                }) : null
                        ]
                      })
              ],
              className: "group flex items-center rounded-lg cursor-pointer transition-all duration-200 ease-in-out " + (
                collapsed ? "px-2 py-3 mx-1 justify-center" : "px-4 py-3 mx-2"
              ) + " " + (
                isSelected ? "bg-blue-50 text-blue-700 shadow-sm border border-blue-100" : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
              ),
              title: collapsed ? label : "",
              onClick: (function (_event) {
                  Curry._1(onClick, undefined);
                })
            });
}

var MenuItem = {
  make: SettingsMenu$MenuItem
};

function SettingsMenu$SectionHeader(props) {
  var collapsed = props.collapsed;
  var icon = props.icon;
  var title = props.title;
  return JsxRuntime.jsx("div", {
              children: collapsed ? JsxRuntime.jsx("span", {
                      children: icon,
                      className: "text-lg",
                      title: title
                    }) : JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: icon,
                              className: "text-lg mr-2"
                            }),
                        JsxRuntime.jsx("h3", {
                              children: title,
                              className: "text-xs font-bold text-gray-500 uppercase tracking-wider"
                            })
                      ],
                      className: "flex items-center"
                    }),
              className: collapsed ? "px-2 pt-6 pb-2 flex justify-center" : "px-4 pt-6 pb-2"
            });
}

var SectionHeader = {
  make: SettingsMenu$SectionHeader
};

function SettingsMenu(props) {
  var collapsed = props.collapsed;
  var selectedSubMenu = props.selectedSubMenu;
  var match = React.useState(function (param) {
        return "";
      });
  var setSearchQuery = match[1];
  var searchQuery = match[0];
  var generalSettings = Belt_Array.concatMany([
        [
          {
            id: "organization_profile",
            label: "Organization Profile",
            icon: "🏢"
          },
          {
            id: "organization_configurations",
            label: "Organization Configurations",
            icon: "⚙️"
          },
          {
            id: "domain_management",
            label: "Domain Management",
            icon: "🌐"
          },
          {
            id: "survey_policy",
            label: "Survey Policy",
            icon: "📋"
          },
          {
            id: "campaign_policy",
            label: "Campaign Policy",
            icon: "📢"
          },
          {
            id: "redirection_urls",
            label: "Redirection URLs",
            icon: "🔗"
          },
          {
            id: "ticket_categories",
            label: "Ticket Categories",
            icon: "🎫"
          },
          {
            id: "text_categories",
            label: "Text Categories",
            icon: "📝"
          },
          {
            id: "ai_configurations",
            label: "AI Models",
            icon: "🤖"
          },
          {
            id: "feature_configurations",
            label: "Feature Configurations",
            icon: "⚙️"
          },
          {
            id: "data_fields",
            label: "Data Fields",
            icon: "📊"
          },
          {
            id: "header_field_mapping",
            label: "Header Field Mapping",
            icon: "🗂️"
          },
          {
            id: "survey_exclusion_rule",
            label: "Survey Exclusion Rule",
            icon: "🚫"
          },
          {
            id: "sender_emails",
            label: "Sender Emails",
            icon: "📤"
          },
          {
            id: "email_content_info",
            label: "Email Content Info",
            icon: "📧"
          },
          {
            id: "notification_rule",
            label: "Notification Rule",
            icon: "🧩"
          }
        ],
        Caml_obj.equal(props.organizationImportEnrichmentEnabled, true) ? [{
              id: "import_enrichment_rules",
              label: "Import Enrichment Rules",
              icon: "🧬"
            }] : []
      ]);
  var messagingChannels = [
    {
      id: "Email",
      label: "Email",
      icon: "📧"
    },
    {
      id: "SMS",
      label: "SMS",
      icon: "💬"
    },
    {
      id: "WhatsApp",
      label: "WhatsApp",
      icon: "📱"
    },
    {
      id: "Social",
      label: "Social",
      icon: "🌟"
    }
  ];
  var templates = [
    {
      id: "email",
      label: "Email Templates",
      icon: "✉️"
    },
    {
      id: "standard_pages",
      label: "Standard Pages",
      icon: "📄"
    }
  ];
  var distribution = [
    {
      id: "API",
      label: "API",
      icon: "🔌"
    },
    {
      id: "sFTP",
      label: "sFTP",
      icon: "📁"
    }
  ];
  var filterItems = function (items) {
    var query = searchQuery.toLowerCase();
    if (query === "") {
      return items;
    } else {
      return Belt_Array.keep(items, (function (item) {
                    return Js_string.includes(item.label.toLowerCase(), query);
                  }));
    }
  };
  var handleSearchChange = function ($$event) {
    var value = $$event.target.value;
    Curry._1(setSearchQuery, (function (param) {
            return value;
          }));
  };
  var renderSection = function (sectionTitle, sectionIcon, items) {
    var filteredItems = filterItems(items);
    if (filteredItems.length !== 0) {
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                  children: [
                    JsxRuntime.jsx(SettingsMenu$SectionHeader, {
                          title: sectionTitle,
                          icon: sectionIcon,
                          collapsed: collapsed
                        }),
                    JsxRuntime.jsx("div", {
                          children: Belt_Array.map(filteredItems, (function (item) {
                                  return JsxRuntime.jsx(SettingsMenu$MenuItem, {
                                              label: item.label,
                                              icon: item.icon,
                                              isSelected: selectedSubMenu === item.id,
                                              onClick: (function (param) {
                                                  var subMenu = item.id;
                                                  RescriptReactRouter.push("/general_settings#" + subMenu);
                                                }),
                                              collapsed: collapsed
                                            }, item.id);
                                })),
                          className: "space-y-1 pb-4"
                        })
                  ]
                });
    } else {
      return null;
    }
  };
  var filteredGeneral = filterItems(generalSettings);
  var filteredMessaging = filterItems(messagingChannels);
  var filteredTemplates = filterItems(templates);
  var filteredDistribution = filterItems(distribution);
  var hasAnyResults = filteredGeneral.length !== 0 || filteredMessaging.length !== 0 || filteredTemplates.length !== 0 || filteredDistribution.length !== 0;
  return JsxRuntime.jsxs("div", {
              children: [
                collapsed ? null : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h2", {
                                children: "Settings",
                                className: "text-lg font-bold text-gray-900 mb-4 px-1"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("span", {
                                              children: "🔍",
                                              className: "text-gray-400 text-sm"
                                            }),
                                        className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                                      }),
                                  JsxRuntime.jsx("input", {
                                        className: "w-full pl-9 pr-10 py-2.5 text-sm text-gray-900 placeholder-gray-400\n                         bg-gray-50 border border-gray-200 rounded-lg\n                         focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent\n                         transition-all duration-200",
                                        placeholder: "Search settings...",
                                        type: "text",
                                        value: searchQuery,
                                        onChange: handleSearchChange
                                      }),
                                  searchQuery !== "" ? JsxRuntime.jsx("button", {
                                          children: JsxRuntime.jsx("span", {
                                                children: "✕",
                                                className: "text-sm"
                                              }),
                                          className: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400\n                             hover:text-gray-600 transition-colors duration-200",
                                          onClick: (function (param) {
                                              Curry._1(setSearchQuery, (function (param) {
                                                      return "";
                                                    }));
                                            })
                                        }) : null
                                ],
                                className: "relative"
                              })
                        ],
                        className: "px-4 pt-6 pb-4 border-b border-gray-200"
                      }),
                JsxRuntime.jsx("div", {
                      children: hasAnyResults ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                renderSection("General", "⚙️", generalSettings),
                                renderSection("Channels", "📡", messagingChannels),
                                renderSection("Templates", "📋", templates),
                                renderSection("Distribution", "🚀", distribution)
                              ]
                            }) : (
                          collapsed ? null : JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: "🔍",
                                          className: "text-4xl mb-3"
                                        }),
                                    JsxRuntime.jsx("p", {
                                          children: "No results found",
                                          className: "text-sm font-medium text-gray-900 mb-1"
                                        }),
                                    JsxRuntime.jsx("p", {
                                          children: "Try searching with different keywords",
                                          className: "text-xs text-gray-500 text-center"
                                        })
                                  ],
                                  className: "flex flex-col items-center justify-center py-12 px-4"
                                })
                        ),
                      className: "flex-1 overflow-y-auto py-2"
                    })
              ],
              className: "bg-white h-full flex flex-col"
            });
}

var make = SettingsMenu;

exports.MenuItem = MenuItem;
exports.SectionHeader = SectionHeader;
exports.make = make;
/* react Not a pure module */
